import { Component, EventEmitter, Input, Output } from '@angular/core';
import { BaseForm } from '@forms/base.form';
import { CompanyDeduction } from '@models/payroll/company/deduction.model';
import { DeductionType } from '@models/payroll/deduction-type.model';

@Component({
    selector: 'app-company-deduction-form',
    templateUrl: './company-deduction.template.html',
})
export class CompanyDeductionForm extends BaseForm {
    @Input() deduction: CompanyDeduction = new CompanyDeduction();
    @Input() deductionTypes: DeductionType[];
    @Output() deductionTypeChange: EventEmitter<number> = new EventEmitter<number>();

    submit(): void {
        if (this.deduction.name?.includes('.')) {
            this.form.controls['name'].setErrors({
                custom: {
                    message: 'forms.payroll.invalidBenefitOrDeductionName',
                },
            });
        }

        this.form.onSubmit(null);
    }
}
